import { AtomTemplate } from '../classes/templates/AtomTemplate.js';
export const atom = (key, value, config) => {
    if (true /* DEV */ && !key) {
        throw new TypeError('Zedux: All atoms must have a key');
    }
    return new AtomTemplate(key, value, config);
};
